<template lang="pug">
//- Alert PAGE
.alert-wrapper
  .alert-box
    //- 一般Alert
    NormalAlert(v-if="this.$root.alert_type === 1")
    //- 訂閱Alert
    //- SubAlert(v-if="this.$root.alert_type === 2")
</template>
<script>
// import SubAlert from '@/common/alert-sub'
import NormalAlert from '@/common/alert-normal'
export default {
  name: 'Alert',
  props: {
    isVisible: {
      type: Boolean,
      default: true
    }
  },
  components: {
    // SubAlert,
    NormalAlert
  },
  computed: {

  },
  created () {
  },
  data () {
    return {

    };
  }
}
</script>
